import { Card, CardContent, Typography } from '@growdash/design-system/atoms';
import competitors_img from '@growdash/growintel/assets/illustrations/competitors-Illustration.png';
import cuisines_img from '@growdash/growintel/assets/illustrations/cuisines-Illustration.png';
import watchlist_img from '@growdash/growintel/assets/illustrations/watchlist-Illustration.png';
import SectionTitle from '@growdash/growintel/components/atoms/section-title';
import { GROWINTEL_PATHS } from '@growdash/growintel/constants/GrowintelPaths';
import { TabValue } from '@growdash/growintel/constants/Tabs';
import { Gem } from 'lucide-react';
import { Link } from 'react-router-dom';

const CARD_ITEMS: {
  value: TabValue;
  title: string;
  description: string;
  image: string;
  link: string;
}[] = [
  {
    value: 'trends',
    title: 'Trends',
    description: `See what's going through the market lately`,
    image: cuisines_img,
    link: GROWINTEL_PATHS.TRENDS,
  },
  {
    value: 'compare',
    title: 'Competitors',
    description: 'Compare your restaurant with the competition',
    image: competitors_img,
    link: GROWINTEL_PATHS.COMPARE,
  },
  {
    value: 'watchlist',
    title: 'Watchlist',
    description: 'Keep an eye in your selected competitors in a single place',
    image: watchlist_img,
    link: GROWINTEL_PATHS.WATCHLIST,
  },
  {
    value: 'search',
    title: 'Search',
    description:
      'Explore restaurants, cuisines, and competitors across the market',
    image: cuisines_img,
    link: GROWINTEL_PATHS.SEARCH,
  },
];

const PageFooter = ({ currentPage }: { currentPage?: TabValue }) => {
  return (
    <div className="mt-6">
      <div className="flex flex-col gap-2 max-lg:flex-wrap max-">
        <SectionTitle title="More Gems For You" Icon={Gem} />
        <Card>
          <CardContent className="grid grid-cols-3 gap-6 max-lg:grid-cols-1">
            {CARD_ITEMS.filter((i) => i.value != currentPage).map((item) => (
              <Link
                key={item.title}
                to={item.link}
                className="flex items-center gap-4 bg-quarternary border border-tertiary rounded-lg p-4 hover:no-underline hover:bg-quarternary hover:opacity-80"
              >
                <img src={item.image} alt={item.title} />
                <div>
                  <Typography className="font-semibold text-primary mb-1">
                    {item.title}
                  </Typography>

                  <Typography className="font-medium text-xs text-tertiary">
                    {item.description}
                  </Typography>
                </div>
              </Link>
            ))}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PageFooter;
